import type { PETComposition } from 'api';

export const getTotalNonPet = (composition: PETComposition): number => {
  return (
    (composition.film ?? 0) +
    (composition.other_plastic ?? 0) +
    (composition.polypropylene ?? 0) +
    (composition.non_plastic ?? 0) +
    (composition.metal ?? 0) +
    (composition.prohibitive ?? 0) +
    (composition.pet_bottle_dirty ?? 0)
  );
};
